import ZionText from '@catalogo/ui-americanas-desktop-zion-text';

export default ZionText;
